export default () => {

  global.initMap = function (targetElement, mapCenter, data, styleData) {

    'use strict';

    var locations = data;

    var centerPosition = new google.maps.LatLng(locations[0][1], locations[0][2]);
    var defaultZoom = 13;
    var delay = {
      animate: true,
      duration: 5000
    };
    // var infowindow = new google.maps.InfoWindow({
    //   content: locationsAsset[0][0],
    // });

    var map = new google.maps.Map(targetElement, {
      zoom: 17,
      center: centerPosition,
      scrollwheel: true,
      navigationControl: true,
      mapTypeControl: false,
      scaleControl: false,
      draggable: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [{
        stylers: [{
          saturation: -100
        }]
      }]
    });
    var iconBase = "/wp-content/themes/kusum/assets/images/marker.png";


    var marker, i;
    var markers = [];

    for (i = 0; i < locations.length; i++) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
        map: map,
        title: locations[i][0],
        icon: {
          url: iconBase,
          scaledSize: new google.maps.Size(38, 52)
        }
      });

      markers.push(marker);

    }

    // google.maps.event.addListener(marker, 'click', function () {
    //   infowindow.open(map, marker);
    // });
  }
}



// WEBPACK FOOTER //
// app/scripts/components/map.js